import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const ProductTaxation = loadable(() => import('./ProductTaxation'), {});
export const ServiceTaxation = loadable(() => import('./ServiceTaxation'), {});
export const Taxation = loadable(() => import('./Taxation'), {});
